export default __webpack_public_path__ + "static/oficina-78a8dd1ca73a1d4cc8b0dd74512e00e6.jpg";